import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "David Jones",
        title: "Key Expert",
        biography: "David Jones is a seasoned key expert with deep knowledge in key duplication, master key systems, and lock mechanisms. With a strong commitment to precision and customer satisfaction, David ensures every key is cut and tested with utmost care. His expertise spans both residential and commercial security solutions.",
        contacts: {
            phone: "111-222-3344",
            email: "david.jones@example.com",
            location: "Locksmith Office #5"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Key Duplication Specialist",
            "Master Key System Designer",
            "Security Consultant",
            "Automotive Key Expert",
            "Lock Technician"
        ],
        skills: [
            { id: 1, title: "Key Duplication", progress: 95 },
            { id: 2, title: "Lock Mechanisms", progress: 90 },
            { id: 3, title: "Access Control Systems", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Sarah White",
        title: "Key Specialist",
        biography: "Sarah White is an expert key specialist with extensive experience in advanced lock systems and security protocols. She focuses on innovative solutions to enhance safety and efficiency for residential and commercial clients.",
        contacts: {
            phone: "222-333-4455",
            email: "sarah.white@example.com",
            location: "Locksmith Office #7"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Advanced Lock Systems Expert",
            "Security Systems Consultant",
            "Residential Security Specialist",
            "Commercial Lock Advisor"
        ],
        skills: [
            { id: 1, title: "Lock Installation", progress: 92 },
            { id: 2, title: "Security Consulting", progress: 88 },
            { id: 3, title: "Access Control", progress: 83 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Michael Johnson",
        title: "Lock Expert",
        biography: "Michael Johnson is a dedicated lock expert with vast knowledge of mechanical and electronic locking systems. He specializes in improving security through innovative lock solutions tailored for both homes and businesses.",
        contacts: {
            phone: "333-444-5566",
            email: "michael.johnson@example.com",
            location: "Locksmith Office #9"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Mechanical Lock Specialist",
            "Electronic Lock Consultant",
            "Security Upgrade Advisor",
            "Residential Lock Expert"
        ],
        skills: [
            { id: 1, title: "Mechanical Locks", progress: 93 },
            { id: 2, title: "Electronic Locks", progress: 89 },
            { id: 3, title: "Security Solutions", progress: 87 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Emily Davis",
        title: "Lock Expert",
        biography: "Emily Davis is a skilled lock expert specializing in state-of-the-art locking mechanisms and security systems. She is committed to providing reliable and innovative lock solutions for both residential and commercial properties.",
        contacts: {
            phone: "444-555-6677",
            email: "emily.davis@example.com",
            location: "Locksmith Office #11"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Lock System Specialist",
            "Security Mechanism Consultant",
            "Commercial Lock Expert",
            "Residential Security Advisor"
        ],
        skills: [
            { id: 1, title: "Lock Installation", progress: 94 },
            { id: 2, title: "Security Systems", progress: 90 },
            { id: 3, title: "Access Control", progress: 86 }
        ]
    }
];

export default team;